import React, { FC } from 'react';
import { Breakpoint, Typography } from '@altibox/design-system-component-lib';

import { ImageProps } from 'app/components/image';

import {
    StyledContainer,
    StyledImage,
    StyledPriceContainer,
    StyledProductInformation,
    StyledProductTitle,
    StyledQuantity,
    StyledQuantityRow,
    StyledValue,
} from './product-information.styled';

interface Props {
    productName: string;
    image: ImageProps;
    price: string;
    amount: number;
    amountText: string;
    establishmentPrice?: string;
}

export const ProductInformation: FC<Props> = (props) => {
    const { productName, image, price, amount, amountText, establishmentPrice } = props;

    return (
        <StyledContainer>
            <StyledImage {...image} />
            <StyledProductInformation>
                <StyledPriceContainer>
                    <StyledProductTitle variant="paragraph2" component="p">
                        {productName}
                    </StyledProductTitle>
                    <StyledValue variant="paragraph2" component="p">
                        {price}
                    </StyledValue>
                </StyledPriceContainer>
                <StyledPriceContainer>
                    <StyledQuantityRow>
                        <Typography variant="paragraph3" component="p">
                            {amountText}
                        </Typography>
                        <StyledQuantity variant="paragraph3" component="p">
                            {amount}
                        </StyledQuantity>
                    </StyledQuantityRow>
                    {establishmentPrice && (
                        <StyledValue variant="paragraph3" component="p" italic={true} maxBreakpoint={Breakpoint.TABLET}>
                            {establishmentPrice}
                        </StyledValue>
                    )}
                </StyledPriceContainer>
            </StyledProductInformation>
        </StyledContainer>
    );
};
